export default "__VITE_ASSET__BNSPdZOK__"